import React, { useState } from "react";
import { styled as materialStyles } from "@mui/material/styles";
import CardContent from "@mui/material/CardContent";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import editIcon from "../../../../assets/Group 41.svg";
import deleteIcon from "../../../../assets/Group 115.svg";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { message } from "antd";
import { useDispatch } from "react-redux";
import {
  Button,
  Container,
  FormControl,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
} from "@mui/material";
import styled from "styled-components";
import {
  SelectSpan,
  StyledCard,
  StyledFilledButton,
  StyledOutlineButton,
} from "../StepMain";
import { VendorCardTitle } from "./vendorReg";
import { VendorCardLabel } from "./bankReg";
import { GSTvalidate } from "../../redux/vendorRegistrationSlice";
import CloseIcon from "@mui/icons-material/Close";
import { useFeature } from "../../../../common/featureFlags/FeatureProvider";
import LocalStorage, { SESSION_KEY } from "../../../../utilities/localStorage";


const Input = materialStyles("input")({
  display: "none",
});

const ContactCard = ({
  index,
  item,
  register,
  onChange,
  onSave,
  onEdit,
  onDelete,
  is_domestic,
}) => {
  const { contact_first_name, contact_last_name, email, mobile_number, designation, edit } = item;
  const contactDesignation = useFeature("contact_designation");

  return (
    <AddContactDiv>
      {edit ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs={6} sx={{ padding: "15px 15px 0 15px" }}>
              <ContactCardTitle style={{ marginLeft: "30px" }}>
                Add Contact details
              </ContactCardTitle>
            </Grid>
            <Grid sx={{ padding: "15px 15px 0 15px" }} item xs={6}>
              <ContactCardTitle style={{ textAlign: "right" }}>
                <Close onClick={() => onDelete(index)}>
                  <CloseIcon style={{ cursor: "pointer" }} />
                </Close>
              </ContactCardTitle>
            </Grid>
          </Grid>
          <CardContent>
            <Container fixed>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Contact person first name</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    id={`contact_first_name_${index}`}
                    style={{ width: "100%" }}
                    {...register(`contact_first_name_${index}`, {
                      required: "Please enter First name",
                    })}
                    InputProps={{
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    placeholder="Enter first name"
                    value={contact_first_name || ""}
                    onChange={(e) => onChange({ target: { name: "contact_first_name", value: e.target.value } }, index)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Contact person last name</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    id={`contact_last_name_${index}`}
                    style={{ width: "100%" }}
                    {...register(`contact_last_name_${index}`, {
                      required: "Please enter Last name",
                    })}
                    InputProps={{
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    placeholder="Enter last name"
                    value={contact_last_name || ""}
                    onChange={(e) => onChange({ target: { name: "contact_last_name", value: e.target.value } }, index)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Contact person email</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    id={`email_${index}`}
                    style={{ width: "100%" }}
                    {...register(`email_${index}`, {
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Entered value does not match email format",
                      },
                      required: "Please enter email",
                    })}
                    InputProps={{
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    placeholder="Enter e-mail"
                    value={email || ""}
                    onChange={(e) => onChange({ target: { name: "email", value: e.target.value } }, index)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Contact person mobile</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    id={`mobile_number_${index}`}
                    style={{ width: "100%" }}
                    {...register(`mobile_number_${index}`, {
                      pattern: {
                        value: is_domestic ? /^(?:\d{10}|\d{12})$/ : /^(?:\d{9}|\d{11})$/,
                        message: is_domestic ? "Phone number should be 10 or 12-digit" : "Phone number should be 9 or 11-digit",
                      },
                    })}
                    InputProps={{
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    placeholder="Enter mobile number"
                    value={mobile_number || ""}
                    onChange={(e) => onChange({ target: { name: "mobile_number", value: e.target.value } }, index)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Designation</VendorCardLabel>
                  {contactDesignation ? (
                    <FormControl variant="standard" style={{ width: "100%" }}>
                      <Select
                        sx={{
                          fontFamily: "var(--font-family-reg)",
                          fontSize: "14px",
                        }}
                        id={`designation_${index}`}
                        value={designation || ""}
                        onChange={(e) => onChange({ target: { name: "designation", value: e.target.value } }, index)}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <span style={{ fontSize: "14px", color: "#A5A5BA" }}>Select designation</span>
                        </MenuItem>
                        <MenuItem value="Sales">Sales</MenuItem>
                        <MenuItem value="Marketing">Marketing</MenuItem>
                        <MenuItem value="Accounts">Accounts</MenuItem>
                        <MenuItem value="Finance">Finance</MenuItem>
                        <MenuItem value="Support">Support</MenuItem>
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`designation_${index}`}
                      style={{ width: "100%" }}
                      {...register(`designation_${index}`)}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter designation"
                      value={designation || ""}
                      onChange={(e) => onChange({ target: { name: "designation", value: e.target.value } }, index)}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6} md={8}></Grid>
                <Grid item xs={6} md={4}>
                  <StyledFilledButton
                    variant="contained"
                    color="success"
                    style={{ textAlign: "right", float: "right" }}
                    onClick={() => onSave(index)}
                  >
                    Save
                  </StyledFilledButton>
                  <br />
                </Grid>
              </Grid>
            </Container>
          </CardContent>
        </>
      ) : (
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={10}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={3}>
                <DarkText>{`${contact_first_name || ""} ${contact_last_name || ""}`}</DarkText>
              </Grid>
              <Grid item xs={1}>
                <Dot />
              </Grid>
              <Grid item xs={3}>
                {email ? <LightText>{email}</LightText> : null}
              </Grid>
              <Grid item xs={1}>
                <Dot />
              </Grid>
              <Grid item xs={2}>
                {mobile_number ? <LightText>{mobile_number}</LightText> : null}
              </Grid>
              <Grid item xs={1}>
                <Dot />
              </Grid>
              <Grid item xs={1}>
                {designation ? <LightText>{designation}</LightText> : null}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1}>
            <Grid container spacing={1}>
              <Grid item xs={6} onClick={() => onEdit(index)}>
                <div style={{ cursor: "pointer" }}>
                  <img src={editIcon} alt="edit" />
                </div>
              </Grid>
              <Grid item xs={6} onClick={() => onDelete(index)}>
                <div style={{ cursor: "pointer" }}>
                  <img src={deleteIcon} alt="delete" />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </AddContactDiv>
  );
};

const LocationInfo = ({
  l_index,
  register,
  onChange,
  phone,
  branch_email,
  fax_number,
  location_state,
  location_city,
  address_line_1,
  address_line_2,
  pin_code,
  errors,
  country,
  is_domestic,
}) => {
  return (
    <CardContent>
      <Container fixed>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>Country</VendorCardLabel>
            <BankDisabledFields>{country}</BankDisabledFields>
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>State</VendorCardLabel>
            <BankDisabledFields>{location_state || ""}</BankDisabledFields>
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>City</VendorCardLabel>
            <BankDisabledFields>{location_city}</BankDisabledFields>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>Address Line 1</VendorCardLabel>
            <BankDisabledFields>{address_line_1}</BankDisabledFields>
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>Address Line 2</VendorCardLabel>
            <BankDisabledFields>{address_line_2}</BankDisabledFields>
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>Postal Code</VendorCardLabel>
            <BankDisabledFields>{pin_code}</BankDisabledFields>
          </Grid>
        </Grid>
        <br />
        {/* <FormControl
              variant="standard"
            > */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>
              Phone<Super>*</Super>
            </VendorCardLabel>

            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              id={`phone_${l_index}`}
              style={{ width: "100%" }}
              {...register(`phone_${l_index}`, {
                pattern: {
                  value: is_domestic ? /^(?:\d{10}|\d{12})$/ : /^(?:\d{9}|\d{11})$/,
                  message: is_domestic ? "Phone number should be 10 or 12-digit" : "Phone number should be 9 or 11-digit",
                },
                required: "Please enter phone number",
              })}
              error={Boolean(errors?.[`phone_${l_index}`])}
              helperText={errors?.[`phone_${l_index}`]?.message}
              InputProps={{
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              placeholder="Enter Phone"
              value={phone || ""}
              onChange={(e) => onChange(e, l_index)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>
              Branch e-mail for communication <Super>*</Super>
            </VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              id={`branch_email_${l_index}`}
              style={{ width: "100%" }}
              {...register(`branch_email_${l_index}`, {
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Entered value does not match email format",
                },
                required: "Please enter email",
              })}
              InputProps={{
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              placeholder="Enter email"
              value={branch_email || ""}
              onChange={(e) => onChange(e, l_index)}
              error={Boolean(errors?.[`branch_email_${l_index}`])}
              helperText={errors?.[`branch_email_${l_index}`]?.message}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>FAX number</VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              id={`fax_number_${l_index}`}
              style={{ width: "100%" }}
              {...register(`fax_number_${l_index}`)}
              InputProps={{
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              placeholder="Enter FAX"
              value={fax_number || ""}
              onChange={(e) => onChange(e, l_index)}
            />
          </Grid>
        </Grid>
        {/* </FormControl> */}
      </Container>
    </CardContent>
  );
};

const ExpandMore = materialStyles((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Close = materialStyles((props, index) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function RecipeReviewCard({
  l_index,
  location_item,
  register,
  expanded,
  handleExpandClick,
  contacts,
  setContacts,
  onChange,
  onDelete,
  errors,
  clearErrors,
  registrationtype,
  createdUser,
  clientId,
  is_domestic,
}) {
  const isVendorApproval = useFeature("vendor_approval_workflow");
  const {
    gst_id,
    location,
    phone,
    branch_email,
    fax_number,
    location_code,
    country,
    state,
    city,
    address_line_one,
    address_line_two,
    postal_code,

    gst_document_image_name,
  } = location_item;
  const isGstRequired = is_domestic === true && registrationtype !== "unregistered";
  const gstRegister = register(`gst_document_image_name_${l_index}`, {
    required: isGstRequired && !gst_document_image_name ? "Please upload GST copy" : false,
  });

  const handleAddContact = () => {
    let contactsCopy = [...(contacts || [])];

    contactsCopy.push({
      contact_first_name: "",
      contact_last_name: "",
      email: "",
      mobile_number: "",
      designation: "",
      edit: true,
    });

    setContacts(contactsCopy);
  };

  const handleContactOnchange = (e, index) => {
    const { name, value } = e.target;

    let contactsCopy = [...(contacts || [])];

    contactsCopy[index] = {
      ...(contactsCopy[index] || {}),
      [name]: value,
    };

    setContacts(contactsCopy);
  };
  const [gSTDoc] = useState("");
  const [selectedlocation, setSelectedlocation] = useState({});
  const [preview, setPreview] = useState("");
  // var user = LocalStorage.getItem(SESSION_KEY);
  // const is_domestic = user.is_domestic;
  const handleLocationOnchange = (e, index) => {
    const unique = gstLocations[index].addresses.find(
      (aLeague) =>
        aLeague.addr.loc + aLeague.addr.st + aLeague.addr.pncd ===
        e.target.value
    );

    setPreview(e.target.value);
    setSelectedlocation(unique);
    onChange(e, index);
  };
  location_item["location"] = selectedlocation.addr
    ? selectedlocation.addr.loc
    : location;
  location_item["state"] = selectedlocation.addr
    ? selectedlocation.addr.stcd
    : state;
  location_item["city"] = selectedlocation.addr
    ? selectedlocation.addr.dst
    : city;
  location_item["address_line_one"] = selectedlocation.addr
    ? `${selectedlocation?.addr?.flno} ${selectedlocation?.addr?.bno} ${selectedlocation?.addr?.bnm}`
    : address_line_one;
  location_item["address_line_two"] = selectedlocation.addr
    ? `${selectedlocation?.addr?.st} ${selectedlocation?.addr?.landMark} ${selectedlocation?.addr?.locality}`
    : address_line_two;
  location_item["postal_code"] = selectedlocation.addr
    ? selectedlocation.addr.pncd
    : postal_code;
  location_item["gst_doc"] = gSTDoc ? gSTDoc : "";
  location_item["country"] = is_domestic === true ? "India" : country;
  const handleSaveContact = (index) => {
    let contactsCopy = [...contacts];

    for (let i = 0; i < contactsCopy.length; i++) {
      const contact = contactsCopy[i];
      const { contact_first_name, contact_last_name, email, mobile_number, designation } = contact;

      if (
        !contact_first_name || contact_first_name.trim() === "" ||
        !contact_last_name || contact_last_name.trim() === "" ||
        !email || email.trim() === "" ||
        !mobile_number || mobile_number.trim() === "" ||
        !designation || designation.trim() === ""
      ) {
        contactsCopy.splice(i, 1);
        setContacts(contactsCopy);
        message.error("All contact fields are required");
        return;
      }
      contactsCopy[i] = {
        ...contact,
        edit: false,
      };
    }
    setContacts(contactsCopy);
  };
  const handleEditContact = (index) => {
    let contactsCopy = [...contacts];

    contactsCopy[index] = {
      ...(contactsCopy[index] || {}),
      edit: true,
    };

    setContacts(contactsCopy);
  };

  const handleDeleteContact = (index) => {
    let contactsCopy = [...contacts];
    // eslint-disable-next-line
    contactsCopy = contactsCopy.filter((_, i) => i != index);

    setContacts(contactsCopy);
  };

  const [gstLocations, setGstLocations] = useState([]);

  const dispatch = useDispatch();
  const gstin = { data: { user_id: createdUser?.id }, gstin: gst_id };
  const validateGST = (e, index) => {
    const GSTRegex =
      /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[Zz]{1}[0-9A-Za-z]{1}$/;
    if (GSTRegex.test(gst_id)) {
      dispatch(GSTvalidate(gstin)).then((data) => {
        if (data.payload.success === true) {
          const data1 = data.payload.gst_api_result.data
            ? data.payload.gst_api_result.data.adadr
            : [];
          const data2 = data.payload.gst_api_result.data
            ? data.payload.gst_api_result.data.pradr
            : [];
          const addresses = [...data1, data2];
          let gstCopy = [...gstLocations];
          gstCopy[index] = {
            ...(gstCopy[index] || {}),
            addresses,
          };

          setGstLocations(gstCopy);
        }
      });
    } else {
      message.error("Please enter valid GST number");
    }
  };

  return (
    <StyledCard>
      <CardContent>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={8}>
              <VendorCardTitle>
                Business location {l_index + 1}
                {onDelete && (
                  <DeleteOuterContainer onClick={() => onDelete(l_index)}>
                    <img src={deleteIcon} alt="del" />
                  </DeleteOuterContainer>
                )}
              </VendorCardTitle>
            </Grid>
            <Grid item xs={6} md={4}>
              <ExpandMore
                expand={expanded}
                onClick={() => handleExpandClick(l_index)}
                aria-expanded={expanded}
                aria-label="show more"
                style={{ textAlign: "right", float: "right" }}
              >
                <ExpandMoreIcon />
              </ExpandMore>
            </Grid>
          </Grid>
        </Box>
      </CardContent>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          {is_domestic === true && registrationtype !== "unregistered" ? (
            <>
              <BusinessRegistrationSubTitle>
                GST information
              </BusinessRegistrationSubTitle>
              <br />
              <Grid>
                <VendorCardLabel>
                  GST ID <Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  id={`gst_id_${l_index}`}
                  defaultValue={gst_id?.toUpperCase() || ""}
                  {...register(`gst_id_${l_index}`, {
                    required: isGstRequired ? "Please enter GST number" : false,
                    pattern: isGstRequired ? {
                      value:
                        /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[Zz]{1}[0-9A-Za-z]{1}$/,
                      message: "Please valid enter GST number",
                    } : undefined,
                  })}
                  error={Boolean(errors?.[`gst_id_${l_index}`])}
                  helperText={errors?.[`gst_id_${l_index}`]?.message}
                  InputProps={{
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  size="small"
                  variant="standard"
                  placeholder="Enter GST and validate"
                  style={{ marginRight: "25px", width: "32%" }}
                  value={gst_id?.toUpperCase() || ""}
                  onChange={(e) => onChange(e, l_index)}
                />
                <Button
                  sx={{
                    background: "var(--button-color)",
                  }}
                  color="success"
                  variant="contained"
                  // type="submit"
                  disabled={gst_id === "" ? true : false}
                  onClick={(e) => validateGST(e, l_index)}
                >
                  validate
                </Button>
              </Grid>
              <br />
              <Grid item xs={12} sm={6} md={3}>
                <FormControl
                  variant="standard"
                  style={{ marginRight: "25px", width: "32%" }}
                  error={Boolean(errors?.[`gst_document_image_name_${l_index}`])}
                >
                  <VendorCardLabel
                    style={{ fontWeight: "500", fontSize: "14px" }}
                  >
                    Upload GST Document<Super>*</Super>
                  </VendorCardLabel>
                  {gst_document_image_name ? (
                    <>
                      <span
                        style={{
                          color: "#4945FF",
                          fontSize: "13px",
                          fontFamily: "var(--font-family-reg)",
                        }}
                      >
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={
                            gst_document_image_name?.name
                              ? gst_document_image_name?.name
                              : gst_document_image_name
                          }
                        />
                        <HighlightOffIcon
                          sx={{ color: "#4945FF", cursor: "pointer" }}
                          fontSize="small"
                          onClick={() =>
                            onChange(
                              {
                                target: {
                                  name: "gst_document_image_name",
                                  value: "",
                                },
                              },
                              l_index
                            )
                          }
                        />
                        <span>Remove </span>
                      </span>
                    </>
                  ) : (
                    <label htmlFor={`gst_document_image_name_${l_index}`}>
                      <Input
                        accept="*"
                        id={`gst_document_image_name_${l_index}`}
                        name={`gst_document_image_name_${l_index}`}
                        value=""
                        onChange={(e) => {
                          gstRegister.onChange(e);
                          if (clearErrors) {
                            clearErrors(`gst_document_image_name_${l_index}`);
                          }
                          onChange(
                            {
                              target: {
                                name: "gst_document_image_name",
                                value: e.target.files[0],
                              },
                            },
                            l_index
                          );
                        }}
                        type="file"
                      />
                      <StyledOutlineButton
                        style={{ marginTop: "5px" }}
                        variant="outlined"
                        component="span"
                      >
                        Upload
                      </StyledOutlineButton>
                    </label>
                  )}
                  {errors?.[`gst_document_image_name_${l_index}`] ? (
                    <FormHelperText>
                      {errors?.[`gst_document_image_name_${l_index}`]?.message}
                    </FormHelperText>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Grid>
              <br />
              <Grid item xs={12} sm={6} md={3}>
                <FormControl
                  variant="standard"
                  style={{ marginRight: "25px", width: "32%" }}
                >
                  <VendorCardTitle>Location information</VendorCardTitle>
                  <VendorCardLabel>
                    Select location <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    defaultValue=""
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id={`location_${l_index}`}
                    {...register(`location_${l_index}`, { required: true })}
                    value={preview}
                    onChange={(e) => handleLocationOnchange(e, l_index)}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select location
                      </span>
                    </MenuItem>
                    {gstLocations[l_index]
                      ? gstLocations[l_index].addresses.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={
                              item.addr.loc + item.addr.st + item.addr.pncd
                            }
                          >
                            <SelectSpan>{`${item.addr.loc}, ${item.addr.st} (${item.addr.pncd})`}</SelectSpan>
                          </MenuItem>
                        ))
                      : ""}
                  </Select>
                </FormControl>
              </Grid>
              <br />
              {location ? (
                <LocationInfo
                  l_index={l_index}
                  register={register}
                  onChange={onChange}
                  phone={phone}
                  branch_email={branch_email}
                  fax_number={fax_number}
                  location_state={selectedlocation.addr.stcd}
                  location_city={selectedlocation.addr.dst}
                  address_line_1={`${selectedlocation?.addr?.flno} ${selectedlocation?.addr?.bno} ${selectedlocation?.addr?.bnm}`}
                  address_line_2={`${selectedlocation?.addr?.st} ${selectedlocation?.addr?.landMark} ${selectedlocation?.addr?.locality}`}
                  pin_code={selectedlocation.addr.pncd}
                  errors={errors}
                  country={country}
                  is_domestic={is_domestic}
                />
              ) : null}
            </>
          ) : (
            <CardContent>
              <Container fixed>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      Branch<Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`location_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`location_${l_index}`, {
                        required: "Please enter Branch name",
                      })}
                      error={Boolean(errors?.[`location_${l_index}`])}
                      helperText={errors?.[`location_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter Branch name"
                      value={location || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      Location Code<Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`location_code_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`location_code_${l_index}`, {
                        required: "Please enter unique Location Code",
                      })}
                      error={Boolean(errors?.[`location_code_${l_index}`])}
                      helperText={errors?.[`location_code_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="e.g. LOC001"
                      value={location_code || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                </Grid>
                <br />
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>Country</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`country_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`country_${l_index}`)}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter Country name"
                      value={country || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      State<Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`state_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`state_${l_index}`, {
                        required: !isGstRequired ? "Plaese enter state " : false,
                      })}
                      error={Boolean(errors?.[`state_${l_index}`])}
                      helperText={errors?.[`state_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter state name"
                      value={state || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      City<Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`city_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`city_${l_index}`, {
                        required: !isGstRequired ? "Plaese enter city " : false,
                      })}
                      error={Boolean(errors?.[`city_${l_index}`])}
                      helperText={errors?.[`city_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter city"
                      value={city || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                </Grid>
                <br />
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      Address Line 1<Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`address_line_one_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`address_line_one_${l_index}`, {
                        required: !isGstRequired ? "Plaese enter address " : false,
                      })}
                      error={Boolean(errors?.[`address_line_one_${l_index}`])}
                      helperText={errors?.[`address_line_one_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter address line 1"
                      value={address_line_one || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>Address Line 2</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`address_line_two_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`address_line_two_${l_index}`)}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter address line2"
                      value={address_line_two || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>Postal Code</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`postal_code_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`postal_code_${l_index}`, {
                        pattern: {
                          value: is_domestic ? /^[1-9][0-9]{5}$/ : /^[a-zA-Z0-9 -]{3,10}$/,
                          message: is_domestic ? "Postal code should be a 6-digit number" : "Postal code should be 3 to 10 alphanumeric characters",
                        },
                        required: "Please enter postal code",
                      })}
                      error={Boolean(errors?.[`postal_code_${l_index}`])}
                      helperText={errors?.[`postal_code_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter postal code"
                      value={postal_code || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                </Grid>
                <br />
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      Phone<Super>*</Super>
                    </VendorCardLabel>

                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`phone_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`phone_${l_index}`, {
                        pattern: {
                          value: is_domestic ? /^(?:\d{10}|\d{12})$/ : /^(?:\d{9}|\d{11})$/,
                          message: is_domestic ? "Phone number should be 10 or 12-digit" : "Phone number should be 9 or 11-digit",
                        },
                        required: "Please enter phone number",
                      })}
                      error={Boolean(errors?.[`phone_${l_index}`])}
                      helperText={errors?.[`phone_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter Phone"
                      value={phone || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      Branch e-mail for communication <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`branch_email_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`branch_email_${l_index}`, {
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Entered value does not match email format",
                        },
                        required: "Please enter email",
                      })}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter email"
                      value={branch_email || ""}
                      onChange={(e) => onChange(e, l_index)}
                      error={Boolean(errors?.[`branch_email_${l_index}`])}
                      helperText={errors?.[`branch_email_${l_index}`]?.message}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>FAX number</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`fax_number_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`fax_number_${l_index}`)}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter FAX"
                      value={fax_number || ""}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                </Grid>
              </Container>
            </CardContent>
          )}
          <br />
          <Grid>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={8}>
                  <VendorCardTitle>Contacts</VendorCardTitle>
                </Grid>
                <Grid item xs={6} md={4}>
                  <StyledOutlineButton
                    onClick={handleAddContact}
                    style={{ textAlign: "right", float: "right" }}
                  >
                    Add Contact
                  </StyledOutlineButton>
                  <br />
                </Grid>
              </Grid>
            </Box>
            <VendorCardSubTitle>
              {contacts.length
                ? ""
                : "No contacts added yet. Start adding contacts by clicking on Add contact button in the right."}
            </VendorCardSubTitle>
            {contacts.map((item, index) => (
              <ContactCard
                key={index}
                index={index}
                item={item}
                register={register}
                onChange={handleContactOnchange}
                onSave={handleSaveContact}
                onEdit={handleEditContact}
                onDelete={handleDeleteContact}
                is_domestic={is_domestic}
              />
            ))}
          </Grid>
        </CardContent>
      </Collapse>
    </StyledCard>
  );
}

export const BusinessRegistrationSubTitle = styled.div`
  font-family: var(--font-family-semi-bold);
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #212134;
`;

export const Super = styled.sup`
  color: red;
`;

export const VendorCardSubTitle = styled.div`
  margin-top: 10px;
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  color: #666687;
`;

export const VendorCardBlankTitle = styled.div`
  margin-top: 10px;
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 30px;
  color: #666687;
`;
export const AddContactDiv = styled.div`
  padding: 10px;
  text-align: left;
  font-family: var(--font-family-reg);
  background: #f5f7f9;
  border: 1px solid #ebeff3;
  border-radius: 10px;
  margin-bottom: 10px;
`;

export const ContactCardTitle = styled.div`
  margin: 10px;
  font-family: var(--font-family-semi-bold);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #000000;
`;

export const ContactIconOuterContianer = styled.div`
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #ebeff3;
  border-radius: 4px;
  /* padding: 7px; */
  padding-left: 6px;
  width: 28px;
  height: 28px;
`;

export const Dot = styled.div`
  background: #a5a5ba;
  height: 4px;
  width: 4px;
  border-radius: 100%;
`;

export const DarkText = styled.span`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
`;

export const LightText = styled.span`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #4a4a6a;
`;

export const BankDisabledFields = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  /* Neutral/900 */

  color: #212134;
`;

export const DeleteOuterContainer = styled.span`
  cursor: pointer;
  background: #f5f7f9;
  border: 1px solid #ebeff3;
  border-radius: 4px;
  /* padding: 7px; */
  padding-left: 6px;
  padding-right: 6px;
  width: 28px;
  padding-bottom: 3px;
  padding-top: 0px;

  height: 28px;
  margin-left: 10px;
`;
